























































































import { Component, Watch } from 'vue-property-decorator';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import Simulation from '@/models/Accounts/Shared/Toolkit/Simulation';

@Component({ name: 'SimulationModeTool' })
export default class extends SaascadaVueDialog {

    dialog: boolean = false;
    simulationModeEnabled: boolean = false;
    selectedSimulation: Simulation = new Simulation();
    newSimulation: Simulation = new Simulation();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.simulationModeEnabled = LendingAccountModule.simulationModeEnabled;
            this.selectedSimulation = LendingAccountModule.simulation;
            this.newSimulation = new Simulation();
            await LendingAccountModule.getSimulations();
        }
    }

    get simulationMode() {
        return LendingAccountModule.simulationModeEnabled;
    }

    get simulations() {
        return LendingAccountModule.simulations;
    }

    close() {
        this.dialog = false;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            if (this.simulationModeEnabled) {
                await LendingAccountModule.startSimulationMode();

                // If there are no simulations yet create a new simulation
                // Else set the selected simulation as the current one
                if (!this.simulations.length) {
                    await LendingAccountModule.createNewSimulation(this.newSimulation);
                }
                else {
                    await LendingAccountModule.setSimulation(this.selectedSimulation);
                }
            }
            else {
                this.selectedSimulation = new Simulation();
                await LendingAccountModule.cancelSimulationMode();
            }
        }
    }


};
